const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const Avatar = require("../../core/view/Avatar");

const styles = require("./styles/StudentName.css");

module.exports = createReactClass({
	displayName: "StudentName",

	propTypes: {
		studentData: PT.object.isRequired,
		forReg: PT.bool,
	},

	render: function() {
		const {forReg, studentData} = this.props;
		const {displayName, username, avatarData} = studentData;

		const usernameEl = username ? (
			<div className={styles.username} key={"n2"}>
				{username}
			</div>
		) : null;

		// Imitates the space usernames take up, but evenly distributed so that
		// setting the username doesn't make things change in size.
		let usernameReplacementSpacing = null;
		if (!username) {
			usernameReplacementSpacing = <div className={styles.noUsernameSpacing} />;
		}

		return (
			<div className={forReg ? styles.nameReg : styles.name}>
				<Avatar
					className={styles.panelAvatar}
					avatar={avatarData}
					fallbackDisplayName={displayName}
					hasRing={true}
				/>
				<div className={forReg ? styles.displayNameReg : styles.displayName}>
					{usernameReplacementSpacing}
					{displayName + " "}
					{usernameEl}
					{usernameReplacementSpacing}
				</div>
			</div>
		);
	},
});
